import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b608c99c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b608c99c&prod&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=b608c99c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b608c99c",
  null
  
)

export default component.exports